var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('nav-bar',{on:{"handlerLi":_vm.gotoPage}}),_vm._m(0),_c('footer-bar',{attrs:{"describeData":_vm.contentData.id}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"container-x"},[_c('div',{staticClass:"main-x"},[_c('div',{staticClass:"notfind-x"},[_c('img',{attrs:{"src":require("@/assets/empty.png"),"alt":"404"}}),_vm._v(" 页面不存在 ")])])])
}]

export { render, staticRenderFns }